<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                labForm: () => import('../forms/LabForm'),
                sampleForm: () => import('../forms/SampleForm'),
                testForm: () => import('../forms/TestForm'),
                fields: [
                    { type: 'autocomplete', text: 'Sample', value: 'sampleId', rules: [v => !!v || 'Sample is required'], isRequired: true, form: () => import('./SampleForm'), apiMethod: 'Samples', claim: 'Samples' },
                    { type: 'autocomplete', text: 'Test', value: 'testId', rules: [v => !!v || 'Test is required'], isRequired: true, form: () => import('./TestForm'), apiMethod: 'Tests', claim: 'Tests' },
                    { type: 'autocomplete', text: 'Lab', value: 'labId', rules: [v => !!v || 'Lab is required'], isRequired: true, form: () => import('./LabForm'), apiMethod: 'Labs', claim: 'Labs' },
                ],
                apiMethod: 'SampleTests',
                formTitle: 'Sample Test',
            }
        },
    };
</script>
